import {helpers} from './helpers.js'

export const tile = {
  mixins: [helpers],
  props: {
    amount: {
      default: 0,
      required: true,
      type: [String, Number]
    },
    name: {
      default: '',
      required: true,
      type: String
    },
    previousAmount: {
      default: 0,
      required: true,
      type: Number
    },
    type: {
      required: true,
      type: [String, Number]
    }
  },
  data () {
    return {
      countUpMoney: {
        prefix: this.$currency
      },
      countUpPercent: {
        suffix: '%'
      },
      direction: '',
      difference: 0
    }
  },
  methods: {
    findOption (type) {
      if (type === 'money') {
        return this.countUpMoney
      }
      if (type === 'percent') {
        return this.countUpPercent
      }
      return null
    },
    loadDifference () {
      let difference = this.numberDifference(this.amount, this.previousAmount)
      this.difference = difference.difference
      this.direction = difference.direction
    }
  },
  mounted () {
    this.loadDifference()
  },
  watch: {
    amount: function () {
      this.loadDifference()
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/mixins/tile.js